"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AssessClipboard_exports = {};
__export(AssessClipboard_exports, {
  default: () => AssessClipboard_default
});
module.exports = __toCommonJS(AssessClipboard_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.0742 8.92188C14.1784 8.81771 14.224 8.70052 14.2109 8.57031C14.2109 8.42708 14.1589 8.3099 14.0547 8.21875C13.9505 8.1276 13.8268 8.08854 13.6836 8.10156C13.5534 8.10156 13.4427 8.14714 13.3516 8.23828L9.67969 12.2617L8.37109 10.875C8.26693 10.7708 8.14323 10.7188 8 10.7188C7.86979 10.7057 7.75911 10.7448 7.66797 10.8359C7.5638 10.9401 7.50521 11.0638 7.49219 11.207C7.49219 11.3372 7.53776 11.4544 7.62891 11.5586L9.30859 13.3359C9.36068 13.388 9.41927 13.4271 9.48438 13.4531C9.54948 13.4792 9.61458 13.4922 9.67969 13.4922C9.74479 13.4922 9.8099 13.4792 9.875 13.4531C9.9401 13.4271 9.9987 13.388 10.0508 13.3359L14.0742 8.92188ZM3.83984 4.83984V16.5C3.83984 16.9557 4.0026 17.3464 4.32812 17.6719C4.65365 17.9974 5.04427 18.1602 5.5 18.1602H15.5C15.9557 18.1602 16.3464 17.9974 16.6719 17.6719C16.9974 17.3464 17.1602 16.9557 17.1602 16.5V4.83984C17.1602 4.37109 16.9974 3.97396 16.6719 3.64844C16.3464 3.32292 15.9557 3.16016 15.5 3.16016H12.4922C12.375 2.79557 12.1602 2.49609 11.8477 2.26172C11.5352 2.02734 11.1771 1.91016 10.7734 1.91016H10.2266C9.82292 1.91016 9.46484 2.02734 9.15234 2.26172C8.83984 2.49609 8.625 2.79557 8.50781 3.16016H5.5C5.04427 3.16016 4.65365 3.32292 4.32812 3.64844C4.0026 3.97396 3.83984 4.37109 3.83984 4.83984ZM12.375 4.17578H12.5898C12.6549 4.17578 12.707 4.20182 12.7461 4.25391C12.7982 4.29297 12.8242 4.34505 12.8242 4.41016V4.83984C12.8242 4.90495 12.7982 4.96354 12.7461 5.01562C12.707 5.05469 12.6549 5.07422 12.5898 5.07422H8.41016C8.34505 5.07422 8.28646 5.05469 8.23438 5.01562C8.19531 4.96354 8.17578 4.90495 8.17578 4.83984V4.41016C8.17578 4.34505 8.19531 4.29297 8.23438 4.25391C8.28646 4.20182 8.34505 4.17578 8.41016 4.17578H8.625C8.80729 4.17578 8.97005 4.1237 9.11328 4.01953C9.25651 3.90234 9.36068 3.75911 9.42578 3.58984L9.46484 3.47266C9.51693 3.31641 9.61458 3.1862 9.75781 3.08203C9.90104 2.97786 10.0573 2.92578 10.2266 2.92578H10.7734C10.9427 2.92578 11.099 2.97786 11.2422 3.08203C11.3854 3.1862 11.4831 3.31641 11.5352 3.47266L11.5742 3.58984C11.6393 3.75911 11.7435 3.90234 11.8867 4.01953C12.0299 4.1237 12.1927 4.17578 12.375 4.17578ZM5.5 4.17578H7.19922C7.1862 4.21484 7.17318 4.25391 7.16016 4.29297C7.16016 4.33203 7.16016 4.37109 7.16016 4.41016V4.83984C7.16016 5.17839 7.28385 5.47135 7.53125 5.71875C7.77865 5.96615 8.07161 6.08984 8.41016 6.08984H12.5898C12.9284 6.08984 13.2214 5.96615 13.4688 5.71875C13.7161 5.47135 13.8398 5.17839 13.8398 4.83984V4.41016C13.8398 4.37109 13.8333 4.33203 13.8203 4.29297C13.8203 4.25391 13.8138 4.21484 13.8008 4.17578H15.5C15.6823 4.17578 15.8385 4.24089 15.9688 4.37109C16.099 4.5013 16.1641 4.65755 16.1641 4.83984V16.5C16.1641 16.6823 16.099 16.8385 15.9688 16.9688C15.8385 17.099 15.6823 17.1641 15.5 17.1641H5.5C5.31771 17.1641 5.16146 17.099 5.03125 16.9688C4.90104 16.8385 4.83594 16.6823 4.83594 16.5V4.83984C4.83594 4.65755 4.90104 4.5013 5.03125 4.37109C5.16146 4.24089 5.31771 4.17578 5.5 4.17578Z",
      fill: "currentColor"
    }
  )
);
const SvgAssessClipboard = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var AssessClipboard_default = SvgAssessClipboard;
